Service = App.loadClass 'core::Angular/Service'

class exports.ProductsService extends Service

    constructor: (@http, @rootScope) ->
        undefined

    all: () ->
        return @http.post 'backend/grower/layers/planting-rx/ng-products'

    bySeedCompany: (id, field_id, crops_id, selected = []) ->
        return @http.post 'backend/grower/layers/planting-rx/ng-products', {
            'seed_company_id': id,
            'field_id': field_id,
            'crops_id': crops_id,
            'selected_ids': selected
        }

    treatments: (id, spp_id) ->
        return @http.post 'backend/grower/layers/planting-rx/ng-treatments', {
            'brands_id': id,
            'spp_id': spp_id
        }
